import { getLinkImageUrl } from "./link/helpers";
import { resolveFileUrl } from "./file-ref";
export function getDomain(url) {
    if (!url)
        return "";
    try {
        const hostname = new URL(url).hostname;
        return hostname.replace(/^www\./, "");
    }
    catch {
        return "";
    }
}
/**
 * Public preview image for link blocks.
 *
 * Resolution order:
 *   1. `content.<subtype>.imageFile` (CDN-routed via `getLinkImageUrl`)
 *   2. Legacy `content.<subtype>.imageUrl` (raw external URL — also via
 *      `getLinkImageUrl`)
 *   3. `block.metadata.thumbnail` — pre-`imageFile` rows still rely on
 *      this CDN-routed thumbnail track.
 *
 * The thumbnail fallback exists for legacy rows where neither the new
 * `imageFile` field nor the legacy `imageUrl` string was populated but
 * the metadata thumbnail was. Going forward, handlers populate
 * `imageFile` directly and the metadata fallback is rarely hit.
 *
 * TODO: Improve ingest for Notion/Google Docs (or a screenshot service)
 * so cloud-doc cards often get a real preview; generic HTML fetch often
 * yields no `og:image`.
 */
export function getLinkPreviewImage(block) {
    if (block.type !== "link")
        return undefined;
    const content = block.content;
    const imageUrl = getLinkImageUrl(content);
    if (imageUrl)
        return imageUrl;
    const thumb = block.metadata.thumbnail;
    if (thumb)
        return resolveFileUrl(thumb);
    return undefined;
}
export function getCardImage(block) {
    switch (block.type) {
        case "image": {
            const img = block.content;
            return img.file ? resolveFileUrl(img.file) : undefined;
        }
        case "link":
            return getLinkPreviewImage(block);
        case "video":
            return block.content.thumbnail;
        default:
            return undefined;
    }
}
